export default function HowIsItUsed() {
    return {
        title: 'How is it used',
        paragraphs: [
            '<div>LTC Linked-Benefit is used by clients who want the flexibility to access their investment for healthcare related expenses as well as for death benefit coverage.<div>',
            '<br/><div> Clients can 1035-exchange an existing permanent life insurance policy to a linked-benefit plan.</div>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/HowIsItUsedData.js